module.exports = __webpack_public_path__ + "img/normal_icon_0.72cbef6.png";